import Locator from './Locator/index';

export default Locator;
